import { render } from "./GLDate.vue?vue&type=template&id=faf3ae3a"
import script from "./GLDate.vue?vue&type=script&lang=ts"
export * from "./GLDate.vue?vue&type=script&lang=ts"
script.render = render

export default script